// extracted by mini-css-extract-plugin
export default {"header":"MyDaters_header__M8rC5","daterHeader":"MyDaters_daterHeader__4kJ7v","subheader":"MyDaters_subheader__jxXd2"};